import React from 'react';
import { SegmentedControl } from 'new/elements/SegmentControl';
import { ReactComponent as TableIcon } from 'new/components/icons/fi-rr-table.svg';
import { ReactComponent as CodeIcon } from 'new/components/icons/view-sql.svg';

export type SourceMode = 'Default' | 'Query';

type Props = {
  mode: SourceMode;
  onChange: (mode: SourceMode) => void;
  disabled?: boolean;
};

const TABLE_ICON = <TableIcon />;
const CODE_ICON = <CodeIcon />;

export const SourceModeToggle: React.FC<Props> = ({ mode, onChange, disabled }) => (
  <SegmentedControl
    value={mode}
    defaultValue="Default"
    iconPosition="start"
    controls={[
      { value: 'Default', label: 'Table', icon: TABLE_ICON, disabled },
      { value: 'Query', label: 'Query', icon: CODE_ICON, disabled },
    ]}
    onControlChange={(_event, value) => onChange(value as SourceMode)}
  />
);
